import { gsap } from '../gsap/setup';

export function initProject() {
  const $project = $('.project');
  if (!$project.length) return;

  const $hero = $project.find('.project-hero');
  const $heroInner = $hero.find('.project-hero__inner');
  const $marquee = $heroInner.find('.project-hero__marquee');
  const $body = $('body');
  const isDark = $body.hasClass('is-dark');

  gsap.to($marquee[0], {
    duration: 1,
    x: '-30%',
    scrollTrigger: {
      trigger: $hero[0],
      start: 'top top',
      endTrigger: $heroInner[0],
      end: 'bottom top',
      scrub: true,
      ease: 'none',
    },
  });

  gsap.to($project[0], {
    scrollTrigger: {
      trigger: $hero[0],
      start: 'bottom center',
      end: '+=20',
      toggleActions: 'play none reverse none',
    },
    color: '#212121',
    backgroundColor: '#f9f8f5',
    onReverseComplete() {
      if (isDark) {
        $body.addClass('is-dark');
      }
    },
    onComplete() {
      if (isDark) {
        $body.removeClass('is-dark');
      }
    },
  });
}
